module.exports = __webpack_public_path__ + "static/media/browser_icon_android.7f33437d.png";